import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import bookings from "@/assets/bookings.svg";
import menuHome from "@/assets/menu-home.svg";
import nnHome1 from "@/assets/nn-home-1.svg";
import nnHome2 from "@/assets/nn-home-2.svg";
import { LearnMoreLink } from "@/components/LearnMoreLink";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-full">
        <div className="flex flex-col w-[47%] mr-12">
          <Link to="/menu/dining">
            <span className="text-5xl/16">A MEETING PLACE FOR ANYONE.</span>
          </Link>
          <span className="text-lg pt-8">
            Our only rule is: come as you are and enjoy as you please. We look
            forward to seeing you.
          </span>
          <span
            onClick={() => navigate({ to: "/bookings" })}
            className="text-xl pt-8 font-frushand cursor-pointer"
          >
            Bookings
          </span>
        </div>
        <img loading="lazy" src={bookings}></img>
      </div>
      <div className="flex justify-between items-center w-full mt-8">
        <img loading="lazy" className="pr-8 pl-6" src={menuHome}></img>
        <div className="flex flex-col w-[47%]">
          <span className="text-xl pt-8 font-frushand cursor-pointer">
            The Menu
          </span>
          <span className="text-xl">BELLY FULL, HEART FULL</span>
          <span className="text-lg pt-6">
            Our menu changes regularly based on seasonality and inspiration, but
            you can always count on it being approachable and nourishing
          </span>
          <span
            onClick={() => navigate({ to: "/menu" })}
            className="text-xl pt-6 font-frushand cursor-pointer"
          >
            View The menu
          </span>
        </div>
      </div>
      <div className="flex w-full mt-8 justify-between">
        <div className="flex flex-col w-[35%] mr-12">
          <span className="text-xl pt-8">
            Tuesdays nights are Neighbourhood Nights, when we dish up a banquet
            of Mediterranean inspired plates of seasonal veg for just IDR
            450.000.
          </span>
          <LearnMoreLink
            className="text-xl pt-8 font-frushand cursor-pointer"
            to="/learn-more"
          />
        </div>
        <img loading="lazy" src={nnHome1} className="pr-6 -mr-16"></img>
        <img loading="lazy" src={nnHome2} className="-mr-14"></img>
      </div>
    </div>
  );
}
